<microstrategy [RBACORG]="RBACORG" [PERMISSION]="PERMISSION" [analyticsEvent]="analyticsEvent"></microstrategy>
